import { YesNoAllOptions } from '~constants/maps';

import { SearchProps } from '~components/form-fields/search';

export const searchFields: SearchProps = {
  last_modified: {
    defaultShow: true,
    type: 'date-range',
    field: 'updated_at',
    caption: 'Last Modified',
  },
  show_unresolved: {
    defaultShow: true,
    type: 'lookup',
    field: 'show_unresolved',
    caption: 'Show Unresolved?',
    placeholder: 'All',
    options: YesNoAllOptions,
  },
};
